import axios, { AxiosError } from 'axios';

import { queryKeys } from '@/tanstack-query/query-keys';
import { useQuery } from '@tanstack/react-query';

export type CutTypeList = {
	id: number;
	title: string;
	title_en: string;
}[];

/** Апи получения списка типов разделки */
export const getCutTypes = async () => {
	try {
		const { data } = await axios.get<CutTypeList>(`${process.env.HOST}/api_v1/cut_types/`);
		return data;
	} catch (error) {
		if (error instanceof AxiosError) {
			console.error(error.response?.data);
		} else {
			console.error(error);
		}
	}
};

export const useCutTypesList = () => {
	return useQuery({
		queryKey: queryKeys.fishCutTypesList,
		queryFn: getCutTypes,
		staleTime: Infinity,
	});
};
